import client from '../utils/client';
import { permissionsUrl } from '../store/constants/api';
import { cookieConstants } from "../store/constants";
import { Cookies } from "react-cookie";
import { unwrapList } from '../utils/apiList';

const cookies = new Cookies();

export const permissionService = {
  permissionRoles,
  permissionShow,
  permissionUpdate,
};

function permissionRoles() {
  return client.get(permissionsUrl)
    .then((response) => unwrapList(response.data && response.data.body))
    .catch(handleResponse);
}

function permissionShow(role) {
  return client.get(permissionsUrl + '/' + encodeURIComponent(role) + '/show')
    .then((response) => {
      const body = response.data && response.data.body ? response.data.body : {};
      return {
        permissions: unwrapList(body.permissions),
        rolePermissions: unwrapList(body.role_permissions),
      };
    })
    .catch(handleResponse);
}

function permissionUpdate(payload) {
  return client.post(permissionsUrl + '/update', payload)
    .then((response) => {
      const body = response.data && response.data.body ? response.data.body : {};
      return {
        permissions: unwrapList(body.permissions),
        rolePermissions: unwrapList(body.role_permissions),
      };
    })
    .catch(handleResponse);
}

function logout() {
  cookies.remove(cookieConstants.TOKEN, { path: "/" });
  cookies.remove(cookieConstants.USER, { path: "/" });
}

function handleResponse(response) {
  response = response.response;
  var data = response.data;
  if (!response.ok) {
    if (response.status === 401) {
      logout();
      window.location.reload(true);
    }
    const error = data.errors;
    return Promise.reject(error);
  }

  return data;
}
